import { Definition } from './index';

export default {
  back: 'Retour aux projets',
  hint: ['Vous pouvez obtenir ', "plus d'informations", "à propos de n'importe quelle expérience en cliquant dessus."],
} as Definition;
